import { useCallback } from 'react';
import { usePortalPrivacyConsent } from '@/context/PortalPrivacyConsent';
import { PrivacyConsentValues } from '@/context/PortalPrivacyConsent/PortalPrivacyConsent.interface';
import TagManager from 'react-gtm-module';

export const useTriggerPortalEvent = () => {
  const { privacyConsent, onPrivacyConsentUpdated } = usePortalPrivacyConsent();

  const triggerPortalDataLayerEvent = useCallback(
    (dataLayer: any) => {
      if (dataLayer) {
        const triggerEvent = () => {
          TagManager.dataLayer({ dataLayer });
        };

        if (privacyConsent && privacyConsent !== PrivacyConsentValues.CONSENT_NEEDED) {
          triggerEvent();
        } else {
          onPrivacyConsentUpdated(triggerEvent);
        }
      }
    },
    [privacyConsent, onPrivacyConsentUpdated],
  );

  return { triggerPortalDataLayerEvent };
};
